import { Card, CardContent, CardMedia } from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import EirInformation from '../eir-information/EirInformation';

/**
 * @param {string|html} title - Title is string parameter.
 * @param {string|html} description - Description can be a string for one paragraph. To get multiple paragraph use Array of strings.
 * @param {string} src - image src path
 * @param {string} alt - image alt text
 */
const InfoCard = ({
  src,
  alt,
  title,
  description,
  style,
  textAlign = 'center',
  titleVariant,
  descriptionVariant,
}) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        background: theme.palette.secondary.contrastText,
        borderRadius: '0.625rem',
        maxWidth: { sm: '282px', xs: '100%' },
        minHeight: { sm: '304px', xs: '350px', md: '250px' },
        m: { sm: 1, lg: '0.5rem' },
        cursor: 'pointer',
      }}
    >
      {src && <CardMedia component='img' alt={alt} image={src} />}
      <CardContent>
        <EirInformation
          title={title}
          description={description}
          textAlign={textAlign}
          style={style}
          titleVariant={titleVariant}
          descriptionVariant={descriptionVariant}
        />
      </CardContent>
    </Card>
  );
};

InfoCard.propTypes = {
  // src: PropTypes.string,
  // alt: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

export default InfoCard;
